import Vuex from 'vuex'
import Vue from 'vue'
import utils from '@/libs/utils'
import { getQueryString } from '@/libs/url'
Vue.use(Vuex)
window.Promise = Promise || {}
const channel = getQueryString('channel');
export default new Vuex.Store({
  state: {
    isPlayBgm: false, // 是否播放背景音乐
    isPlayAudio: false, // 是否播放其他音频
    showWxToast: false, // 微信二维码弹窗
    isShowVideo: false, // 视频弹窗
    videoSrc: '', // 视频弹窗播放的视频src
    audioSrc: '', // 音频
    contact: {}, // 联系方式 下载 相关
    appPlat: utils.app.which() === 'none' ? '' : utils.app.which(),
    showQR: false, // app store 预约弹窗
    curPage: null, // 当前页面，0开始
    curTab: 0, // 当前新闻tabs下标
    videoInfo: {},
    showLcbToast: false, // 里程碑弹窗
    channel: channel ? channel : 'web',
    down: {},
    adList: [],
    newsSwiperList: [],
    tabsList: []
  },
  mutations: {
    setNewsTabList(state, params) {
      state.tabsList = params
    },
    setDown(state, params) {
      state.down = params
    },
    setAdList(state, params) {
      state.adList = params
    },
    setNewsSwiperList(state, params) {
      state.newsSwiperList = params
    },
    setCurTab(state, params) {
      state.curTab = params
    },
    setCurPage(state, params) {
      state.curPage = params
    },
    setShowQR(state, params) {
      state.showQR = params
    },
    setIsPlayBgm(state, params) {
      state.isPlayBgm = params
    },
    setIsPlayAudio(state, params) {
      state.isPlayAudio = params
    },
    setShowWxToast(state, params) {
      state.showWxToast = params
    },
    setShowVideo(state, params) { // src: 视频地址， isShow: 是否展示视频播放器
      state.isShowVideo = params.isShow
      state.videoSrc = params.src
    },
    setVideoInfor(state, params) {
      state.videoInfo = params
    },
    setAudioSrc(state, params) {
      state.audioSrc = params
    },
    setContact(state, params) {
      state.contact = params
    },
    setShowLcbToast(state, params) {
      state.showLcbToast = params
    }
  },
  actions: {
    setNewsTabList({ commit }, params) {
      commit('setNewsTabList', params)
    },
    changeDown({ commit }, params) {
      commit('setDown', params)
    },
    setAdList({ commit }, params) {
      commit('setAdList', params)
    },
    setNewsSwiperList({ commit }, params) {
      commit('setNewsSwiperList', params)
    },
    changeCurTab({ commit }, params) {
      commit('setCurTab', params)
    },
    changeCurPage({ commit }, params) {
      commit('setCurPage', params)
    },
    changeIsPlayBgm({ commit }, params) {
      commit('setIsPlayBgm', params)
    },
    changeIsPlayAudio({ commit }, params) {
      commit('setIsPlayAudio', params)
    },
    changeShowWxToast({ commit }, params) {
      commit('setShowWxToast', params)
    },
    changeShowVideo({ commit }, params) {
      commit('setShowVideo', params)
    },
    changeVideoInfor({ commit }, params) {
      commit('setVideoInfor', params)
    },
    setAudioSrc({ commit }, params) {
      commit('setAudioSrc', params)
    },
    setContact({ commit }, params) {
      commit('setContact', params)
    },
    setShowQR({ commit }, params) {
      commit('setShowQR', params)
    },
    changeShowLcbToast({ commit }, params) {
      commit('setShowLcbToast', params)
    }
  },
  plugins: []
})
